<app-entity-overview #overviewComponent
                            [entityOverviewBaseComponent]="this"
                            [isEmbedded]="true"
                            [stereotyped]="false">
</app-entity-overview>
